export function isTest() {
  if (typeof process === 'undefined') return false;
  return process.env['NODE_ENV'] === 'test';
}
